<template>
  <el-select
    filterable
    :value="value"
    @input="onInput"
    @change="onChange"
    :clearable="clearable"
    :multiple="multiple"
    :disabled="disabled"
    :filterable="filterable"
  >
    <el-option v-if="emptyLabel" :label="emptyLabel" :value="emptyValue" />
    <el-option
      v-for="it in optionList"
      :key="it.value"
      :label="it.label"
      :value="it.value"
    />
  </el-select>
</template>

<script>
export default {
  name: "ExSelect",
  props: {
    options: [Array, Function],
    value: null,
    emptyLabel: String,
    emptyValue: {
      default: "",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    filterable: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      optionList: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.loadOptions();
      },
      immediate: true,
    },
  },
  methods: {
    async loadOptions() {
      const options = this.options || [];
      if (typeof options === "function") {
        this.optionList = await options();
      } else {
        this.optionList = options;
      }
    },
    onInput(value) {
      this.$emit("input", value);
    },
    onChange(value) {
      this.$emit("change", value);
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/ExSelect/index.vue